import { Music2 } from "lucide-react";

const DEFAULT_ITEMS = ["100% Custom Lyrics", "12-Hr Express Delivery", "Acoustic, Pop, Soul & Folk", "Guaranteed Happy Tears", "High Quality MP3 + Lyric Card"];

export default function Marquee({ content }) {
  const items = content?.marquee_items
    ? content.marquee_items.split("\n").map((s) => s.trim()).filter(Boolean)
    : DEFAULT_ITEMS;
  const row = [...items, ...items, ...items];
  return (
    <div className="bg-sunny border-y-[3px] border-ink py-4 overflow-hidden shadow-[0_4px_0_#2D1A32]" data-testid="marquee-strip">
      <div className="animate-marquee-x flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-display font-semibold text-lg sm:text-xl text-ink whitespace-nowrap">
            <span className="px-7">{item}</span>
            <Music2 size={16} className="text-pink" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
}
